import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection, isDevMode, LOCALE_ID } from '@angular/core';
import { provideRouter } from '@angular/router';
import { registerLocaleData } from '@angular/common';
import localeEsAr from '@angular/common/locales/es-AR';

import { routes } from './app.routes';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideHttpClient } from '@angular/common/http';
import { AngularFireModule } from '@angular/fire/compat';
import { SETTINGS as FIRESTORE_COMPAT_SETTINGS } from '@angular/fire/compat/firestore';
import { environment } from '../environments/environment';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideServiceWorker } from '@angular/service-worker';
import { DialogService } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { MAT_DATE_LOCALE, provideNativeDateAdapter } from '@angular/material/core';
import { ButacoPreset } from 'projects/lib/styles/ButacoPreset';
import { NgxPermissionsModule } from 'ngx-permissions';

// Register Spanish locale data
registerLocaleData(localeEsAr);

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideAnimationsAsync(),
    provideHttpClient(),
    importProvidersFrom(AngularFireModule.initializeApp(environment.firebase)),
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    // Drop `undefined` fields instead of throwing on set()/update(). Prevents a
    // partial "husk" user object from aborting a save mid-way (SPEC-2026-001).
    { provide: FIRESTORE_COMPAT_SETTINGS, useValue: { ignoreUndefinedProperties: true } },
    provideAuth(() => getAuth()),
    provideServiceWorker('ngsw-worker.js', {
      enabled: !isDevMode(),
      registrationStrategy: 'registerWhenStable:30000'
    }),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    importProvidersFrom(AngularFireModule.initializeApp(environment.firebase)),
    provideAnimationsAsync(),
    provideAuth(() => getAuth()),
    provideHttpClient(),
    importProvidersFrom(NgxPermissionsModule.forRoot()),
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: MAT_DATE_LOCALE, useValue: 'es-AR' },
    provideNativeDateAdapter(),
    providePrimeNG({
      theme: {
        preset: ButacoPreset
      }
    }),
    DialogService,
    MessageService
  ],
};
